import { Grid, Typography, makeStyles } from '@material-ui/core';
import { Call, Email, ListAlt, Note, People } from '@material-ui/icons';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import { useDispatch } from 'react-redux';
import { showProgress } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { ErrorToast } from '../utils/Utils';
import 'react-calendar/dist/Calendar.css';
import ZeroState from '../common/ZeroState';
import FileIcon from '../../assets/FileIcon';
import { apiEndpoints } from '../../constants/apiEndpoints';

const useStyles = makeStyles(() => ({
  heading: {
    width: '100%',
    height: '50px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  hubspot: {
    height: '100%',
    width: '33%',
    padding: '10px',
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '5px',
  },
  calendarContainer: {
    height: '50%',
    width: '90%',
    padding: '0px 20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  activityContainer: {
    height: '40%',
    width: '95%',
    padding: '10px 10px',
    overflow: 'hidden',
    marginTop: '25px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  activities: {
    height: '90%',
    width: '90%',
    overflowY: 'auto',
    padding: '10px',
  },
  activity: {
    width: '95%',
    height: '60px',
    marginTop: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '15px',
    border: '1px solid #E4E7EC',
  },
  icon: {
    width: '50px',
    height: '50px',
    background: '#F2F4F7',
    borderRadius: '4px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    width: '260px',
    height: '60px',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '-5px',
  },
  subtext: {
    fontSize: '12px',
    marginTop: '-15px',
  },
  pastSchedules: {
    borderRadius: '50%',
    background: '#D9D6FE',
    color: '#622FEE',
    cursor: 'pointer',
  },
  futureSchedules: {
    borderRadius: '50%',
    border: '1px solid #F79009 !important',
    cursor: 'pointer',
  },
  currentDate: {
    borderRadius: '50%',
    background: '#622FEE !important',
  },
  allDate: {
    color: '#000',
    borderRadius: '50%',
  },
  date: {
    marginBottom: '20px',
    width: '100%',
  },
}));
export default function Hubspot({ selctedDealerId }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [hubActivity, setHubActivity] = useState([]);
  const [calValue, setCalValue] = useState(new Date());

  const getDateRange = (activeStartDate) => {
    const firstDate = new Date(activeStartDate.getFullYear(), activeStartDate.getMonth(), 1);
    const lastDate = new Date(activeStartDate.getFullYear(), activeStartDate.getMonth() + 1, 0);

    return {
      startDate: moment(firstDate).format('YYYY-MM-DD'),
      endDate: moment(lastDate).format('YYYY-MM-DD'),
    };
  };

  const [selectedTimeRange, setSelectedTimeRange] = useState(getDateRange(new Date()));

  const handleCalClick = (val) => {
    setCalValue(val);
  };

  const fetchHubspotActivity = async (id) => {
    dispatch(showProgress(true));
    const customDateId = 4;

    const selectedDate = moment(calValue).format('YYYY-MM-DD');
    try {
      const response = await service.post(apiEndpoints.PX_HUBSPOT_ACT.replace('ID', id), {
        filters: {
          time: {
            ...selectedTimeRange,
            type: customDateId + 1,
          },
          calendarDateSelected: selectedDate,
        },
      });
      setHubActivity(response);
      dispatch(showProgress(false));
    } catch (err) {
      ErrorToast(err);
      dispatch(showProgress(false));
    }
  };

  useEffect(() => {
    if (selctedDealerId && selectedTimeRange.endDate && selectedTimeRange.startDate) {
      fetchHubspotActivity(selctedDealerId);
    }
  }, [selctedDealerId, calValue, selectedTimeRange]);

  const tileClassName = ({ date }) => {
    const formattedDate = moment(date).format('YYYY-MM-DD');
    const { prevSchedules, upcomingSchedules } = getSchedules();

    const pasts = prevSchedules.includes(formattedDate);
    const futures = upcomingSchedules.includes(formattedDate);
    if (pasts) {
      return classes.pastSchedules;
    }
    if (futures) {
      return classes.futureSchedules;
    }
    if (formattedDate === moment(new Date()).format('YYYY-MM-DD')) {
      return classes.currentDate;
    }
    return classes.allDate;
  };

  const getSchedules = () => {
    const prevSchedules = [];
    const upcomingSchedules = [];

    Object.entries(hubActivity?.statusMap || {}).forEach(([date, value]) => {
      if (value === 1) {
        prevSchedules.push(date);
      } else if (value === 2) {
        upcomingSchedules.push(date);
      }
    });

    return { prevSchedules, upcomingSchedules };
  };

  const maxSelectableDate = () => {
    const today = new Date();
    const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    return lastDayOfMonth;
  };

  const handleCustomDate = (activeStartDate) => {
    setSelectedTimeRange(getDateRange(activeStartDate));
  };

  const getActivity = ({ type, heading, subText }) => {
    const activityIcons = {
      notes: <Note style={{ fontSize: '30px' }} />,
      emails: <Email style={{ fontSize: '30px' }} />,
      tasks: <ListAlt style={{ fontSize: '30px' }} />,
      calls: <Call style={{ fontSize: '30px' }} />,
      meetings: <People style={{ fontSize: '30px' }} />,
    };

    const Icon = activityIcons[type];

    return (
      <Grid className={classes.activity}>
        <Grid className={classes.icon}>{Icon}</Grid>
        <Grid className={classes.content}>
          <Typography className={classes.heading}>{heading}</Typography>
          <Typography className={classes.subtext}>{subText}</Typography>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid className={classes.hubspot}>
      <Typography variant="h6" className={classes.title}>
        Hubspot Activity
      </Typography>
      <Grid className={classes.calendarContainer}>
        <div style={{ width: '320px', height: '250px' }}>
          <Calendar
            onChange={(value) => handleCalClick(value)}
            value={calValue}
            tileClassName={tileClassName}
            maxDate={maxSelectableDate()}
            onActiveStartDateChange={({ activeStartDate }) => handleCustomDate(activeStartDate)}
          />
        </div>
      </Grid>
      <Grid className={classes.activityContainer}>
        <Typography className={classes.date}> {moment(calValue).format('ddd, MMM DD')} </Typography>
        {hubActivity?.data?.list?.length > 0 ? (
          <Grid className={classes.activities}>{hubActivity?.data?.list?.map((data) => getActivity(data))}</Grid>
        ) : (
          <ZeroState
            Icon={FileIcon}
            text="No events for the selected date."
            style={{ height: '300px', width: '500px' }}
            cardWidth="24vw"
          />
        )}
      </Grid>
    </Grid>
  );
}
